import React from 'react'

import { CheckboxMenu, SurfaceContainer } from '@caudena/core/ui-kit'
import { InputDropdown } from '@caudena/core/ui-kit'
import { Typography } from '@caudena/core/ui-kit'
import { Container } from '@caudena/core/ui-kit'
import capitalizeFirstLetter from '@caudena/core/utils/capitalizeFirstLetter'

import { FieldProps } from './types'

const options = [
  {
    label: <Typography color="magenta">High</Typography>,
    value: 'high' as const,
  },
  {
    label: <Typography color="yellow">Medium</Typography>,
    value: 'medium' as const,
  },
  {
    label: <Typography color="blue">Low</Typography>,
    value: 'low' as const,
  },
]

const Severity = ({ value, onChange }: FieldProps<Array<string>>) => {
  const handleInputClear = () => {
    onChange([])
  }

  const handleChange = (selected) => {
    onChange(selected.length ? selected : [])
  }

  const printValue =
    value && value?.length > 0
      ? value?.map(capitalizeFirstLetter).join(' / ')
      : ''

  return (
    <InputDropdown
      clearable
      sameWidth
      padded={false}
      variant="outline"
      startAddon={{ label: 'Severity:' }}
      value={printValue}
      placeholder="Any"
      onClear={handleInputClear}
    >
      <SurfaceContainer spaces={'md'}>
        <CheckboxMenu options={options} value={value} onChange={handleChange} />
      </SurfaceContainer>
    </InputDropdown>
  )
}

export default Severity
